<!-- Main view/routes wrapper-->
<!-- An Angular application's main content is typically produced inside a <router-outlet> tag. -->
<router-outlet></router-outlet>
<ng4-loading-spinner [timeout]="1000000" [template]="STR_template"></ng4-loading-spinner>